import { SectionCarousel } from '@sbercloud/uikit-product-site-section';
import { ReviewProps } from 'src/components/Carousel/types';
import { useLayoutType } from 'src/hooks/useLayoutType';

import { CarouselBase } from '../CarouselBase';

export type ReviewsProps = {
  id?: string;
  cards: ReviewProps[];
  title?: string;
};

export function ReviewsCarousel({ id, cards, title }: ReviewsProps) {
  const layoutType = useLayoutType();

  return (
    <SectionCarousel
      id={id}
      layoutType={layoutType}
      title={title}
      itemMinWidth={0}
      maxItemsPerPage={1}
      infiniteScroll
    >
      {cards.map(({ id, title, description, text }) => (
        <CarouselBase.Review
          key={id}
          title={title}
          description={description}
          text={text}
        />
      ))}
    </SectionCarousel>
  );
}
